export const commonStyles = (FOUNDATIONS, FONT) => ({
    container: {
        display: 'flex',
        width: 'inherit',
    },
    barContainer: {
        width: '100%',
        position: 'relative',
    },
    bar: {
        position: 'absolute',
        top: '50%',
        left: '0',
        width: '100%',
        height: FOUNDATIONS.size_50,
    },
    progressBar: {
        position: 'absolute',
        top: '50%',
        left: '0',
        width: '0',
        height: FOUNDATIONS.size_50,
    },
});
//# sourceMappingURL=commonStyles.js.map